































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class DFloater extends Vue {
    @Prop({ type: Boolean, default: () => false })
    visible!: boolean;

    @Prop({ type: String, default: () => "无标题" })
    title!: string;

    closeDialog() {
      this.$emit("update:visible", false);
      this.$emit("close");
    }

    mounted() {
      document.body.appendChild(this.$el);
    }

    beforeDestroy() {
      const parent = this.$el.parentNode;
      if (parent) {
        parent.removeChild(this.$el);
      }
    }
}
